import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { UserManager, UserManagerSettings, User } from 'oidc-client';
import { BehaviorSubject } from 'rxjs';

import { BaseService } from '../../shared/base.service';
import { ConfigService } from '../../shared/config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseService {

  // Observable navItem source
  private _authNavStatusSource = new BehaviorSubject<boolean>(false);
  // Observable navItem stream
  authNavStatus$ = this._authNavStatusSource.asObservable();

  private manager: UserManager | null;
  private user: User | null;
  navbar: any;
  status = 0;
  showlogin = true;

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.manager = new UserManager(getClientSettings(configService));


    this.manager.getUser().then(user => {
      this.user = user;
      this._authNavStatusSource.next(this.isAuthenticated());
    });
  }

  login() {
    return this.manager.signinRedirect();
  }

  async completeAuthentication() {
    this.user = await this.manager.signinRedirectCallback();
    this._authNavStatusSource.next(this.isAuthenticated());
  }

  register(userRegistration: any) {
    return this.http.post(this.configService.authApiURI + '/account', userRegistration).pipe(catchError(this.handleError));
  }

  isAuthenticated(): boolean {
    return this.user != null && !this.user.expired;
  }

  get authorizationHeaderValue(): string {
    return `${this.user.token_type} ${this.user.access_token}`;
  }

  get partnerStatus(): any {
    return this.status;
  }

  get name(): string {
    let aux = (this.user != null && this.user.profile != null && this.user.profile.name != null) ? this.user.profile.name : '';
    if (aux == 'pindi_de_ejemplo') {
      return 'PINDI_TECA';
    } else {
      return aux;
    }
  }

  get roles(): any {
    return (this.user != null && this.user.profile != null && this.user.profile.role != null) ? this.user.profile.role : [];
  }

  get sub(): any {
    return (this.user != null && this.user.profile != null && this.user.profile.sub != null) ? this.user.profile.sub : ''
  }
  get isAdmin(): boolean {
    return (this.user != null && this.user.profile != null && this.user.profile.is_admin === 'True') ? true : false;
  }

  get idpartner(): string {
    return (this.user != null && this.user.profile != null && this.user.profile.idpartner != null) ? this.user.profile.idpartner : '';
  }

  get password_expiry_days_remaining(): string {
    return (this.user != null && this.user.profile != null && this.user.profile.password_expiry_days_remaining != null) ? this.user.profile.password_expiry_days_remaining : '99';
  }

  get EmployeeId(): string {
    return (this.user != null && this.user.profile != null && this.user.profile.EmployeeId != null) ? this.user.profile.idpartner : 'MPA-Unknown';
  }

  get canal(): string {
    if (this.user != null && this.user.profile != null && this.user.profile.is_admin === 'True') {
      return 'Admin';
    } else {
      return (this.user != null && this.user.profile != null && this.user.profile.canal != null) ? this.user.profile.canal : '';
    }
  }

  get center(): string {
    if (this.user != null && this.user.profile != null && this.user.profile.is_admin === 'True' &&
      (this.user.profile == null || this.user.profile.center == null)) {
      return 'Admin';
    } else {
      return (this.user != null && this.user.profile != null && this.user.profile.center != null) ? this.user.profile.center : '';
    }
  }

  async signout() {
    await this.manager.signoutRedirect();
  }
}

export function getClientSettings(configService: ConfigService): UserManagerSettings {
  return {
    authority: configService.authApiURI,
    client_id: 'angular_spa',
    redirect_uri: configService.spaURI + '/auth-callback',
    post_logout_redirect_uri: configService.spaURI + '/',
    response_type: 'id_token token',
    scope: 'openid profile web_api', // email management.read management.write order',
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
    silent_redirect_uri: configService.spaURI + '/silent-refresh.html'
  };
}

